import { render, staticRenderFns } from "./attendanceByExamYearDetails.vue?vue&type=template&id=b54382f6&"
import script from "./attendanceByExamYearDetails.vue?vue&type=script&lang=js&"
export * from "./attendanceByExamYearDetails.vue?vue&type=script&lang=js&"
import style0 from "./attendanceByExamYearDetails.vue?vue&type=style&index=0&id=b54382f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports